import {
  Col,
  Form,
  Input,
  Row,
  Space,
  Table,
  Upload,
  Modal,
  UploadFile,
  Checkbox,
  Select,
  Divider,
  Image,
} from 'antd';
import { Content } from 'antd/lib/layout/layout';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import Button from 'components/Button';
import { useMutation, useQuery } from 'react-query';
import { IGetProductUploadQuery } from 'interface/user.interface';
import useQueryParam from 'hooks/useQueryPrams';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import { SyncIcon } from 'assets/svg';
import useCategoryManagementStore from 'store/categoryManagementStore';
import { useEffect, useState } from 'react';
import { UploadProps } from 'antd/lib';
import * as XLSX from 'xlsx';
import ProductApi from 'apis/ProductApi';
import {
  IProduct,
  InsertProductForPortFolio,
} from 'interface/product.interface';
import PortfolioApi from 'apis/PortfolioApi';
import { STATUS } from 'constants/reponseStatus';
import handleError401 from 'utils/handleError401';
import { IPortfolio } from 'interface/portfolio.interface';
import { PRODUCT_POF_STATUS, PRODUCT_STATUS } from 'constants/productStatus';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import { ColumnsType } from 'antd/es/table';
import PopupConfirmBase from 'components/PopupConfirmBase';
import { HocChangePagination } from 'utils/HocChangePagination';
import DeclareCartPage from './DeclareCart';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { Option } from 'antd/es/mentions';
import { openNotificationWithIcon } from 'utils/notification';
import updateQueryStringParameter from 'utils/updateQueryStringParameter';

interface Iparam {
  id: string;
  pof_type_code: string;
}
export default function DeclareCartProducts(): JSX.Element {
  const history = useHistory();
  const { id, pof_type_code } = useParams<Iparam>();

  const location = useLocation<{ edit?: boolean }>();

  const setStep = useCategoryManagementStore((state) => state.setStep);
  const [modalSyncVisible, setModalSyncVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [excelData, setExcelData] = useState<InsertProductForPortFolio[]>([]);
  const [options, setOptions] = useState<
    { key: string; value: any; label: string }[]
  >([
    // {
    //   key: '1',
    //   label: 'Thanh 1',
    //   value: '1Thanh 1',
    // },
    // {
    //   key: '2',
    //   label: 'Thanh 2',
    //   value: 'Thanh 2',
    // },
  ]);
  const [products, setProductData] = useState<IProduct[]>([]);
  const [total, setProductTotalData] = useState<number>(0);
  // const [lstPortfolio, setListPortfolio] = useState<IPortfolio[]>([]);
  const [listPortfolioSelected, setListPortfolioSelected] = useState<string[]>(
    []
  );
  const [listProductSelected, setListProductSelected] = useState<IProduct[]>(
    []
  );
  const [selectedFile, setSelectedFile] = useState<UploadFile>();
  const [checkAll, setCheckAll] = useState(false);

  const [pagination, setPagination] = useState({
    page: 1,
    page_size: DEFAULT_PAGE_SIZE,
  });

  const columns: ColumnsType<IProduct> = [
    {
      title: (
        <Checkbox
          checked={checkAll}
          onChange={(e) => {
            if (e.target.checked) {
              listPortfolioSelected &&
                listPortfolioSelected.length > 0 &&
                getAllProducts();
            } else {
              setListProductSelected([]);
            }
            setCheckAll(e.target.checked);
          }}
        />
      ),
      dataIndex: 'isSelected',
      width: 80,
      align: 'center',
      render: (text, record) => (
        <Checkbox
          checked={listProductSelected
            .map((item) => item.ma_mau + item.pof_code)
            .includes(record.ma_mau + record.pof_code)}
          onChange={(e) => handleCheckboxChange(record, e.target.checked)}
        />
      ),
    },
    {
      title: 'STT',
      dataIndex: 'stt',
      width: 80,
      render: (text, record, index) =>
        index + 1 + pagination.page_size * (pagination.page - 1),
    },
    {
      title: 'Mã mẫu',
      dataIndex: 'ma_mau',
      width: 177,
    },
    {
      title: 'Hình ảnh',
      dataIndex: 'image_default',
      render: (record: any) => {
        return (
          <Image
            className="border border-solid border-neutral-90 rounded-lg"
            src={record}
            width={50}
            height={50}
          />
        );
      },
      width: 100,
    },
    {
      title: 'Tên mẫu',
      dataIndex: 'ten_mau',
      width: 261,
    },
    {
      title: 'Ni',
      dataIndex: 'ni_sanpham',
      width: 100,
    },
    {
      title: 'Bộ phận phát triển',
      dataIndex: 'nhan_hang',
      width: 261,
    },
    {
      title: 'Ngành hàng',
      width: 115,
      dataIndex: 'nganh_hang',
    },
    {
      title: 'Dòng hàng',
      dataIndex: 'dong_hang',
      width: 148,
    },
    {
      title: 'X-man',
      dataIndex: 'xman',
      width: 148,
    },
    {
      title: 'Chủng loại',
      dataIndex: 'chung_loai',
      width: 148,
    },
    {
      title: 'Kết luận đánh giá 3 tiêu chí',
      dataIndex: 'kldg_3tc',
      width: 140,
    },
    {
      title: 'Doanh thu 6 tháng gần nhất',
      // dataIndex: 'chung_loai',
      width: 148,
      align: 'right',
    },
    {
      title: 'Tổng SL tồn hiện tại',
      dataIndex: 'tongsl_ton',
      width: 112,
      align: 'right',
    },
    {
      title: 'Tổng giá trị tồn hiện tại',
      dataIndex: 'tong_giatri',
      width: 112,
      align: 'right',
    },
    {
      title: 'Giá trung bình',
      dataIndex: 'gia_tb',
      width: 112,
      align: 'right',
    },
    {
      title: 'Chi nhánh',
      dataIndex: 'chi_nhanh',
      width: 112,
    },
    {
      title: 'Cửa hàng',
      dataIndex: 'cua_hang',
      width: 112,
    },
    {
      title: 'Số lượng phân bổ',
      dataIndex: 'so_luong_phan_bo',
      width: 112,
    },
    {
      title: 'Vốn tồn phân bổ',
      dataIndex: 'von_ton_phan_bo',
      width: 112,
    },
    {
      title: 'Product code',
      dataIndex: 'pro_code',
      width: 112,
    },
    {
      title: 'Pof code',
      dataIndex: 'pof_code',
      width: 112,
    },
    {
      fixed: 'right',
      align: 'center',
      width: 0,
    },
  ];

  // const { data: lstPortfolio } = useQuery(['getProductGroup'], () =>
  //   PortfolioApi.search(pof_type_code, '')
  // );

  const { data: lstPortfolio } = useQuery(['getProductGroup'], () =>
    PortfolioApi.searchByStatus(2, pof_type_code, '')
  );

  // const { mutate: searchPortfolio, isLoading: getPortfoliosLoading } =
  //   useMutation(
  //     (search: string) =>
  //       PortfolioApi.search(pof_type_code, search),

  //     {
  //       onSuccess: (response: any) => {
  //         if (response.status === STATUS.SUCCESS) {
  //           console.log('response nè: ', response.data);
  //           setListPortfolio(response.data);
  //           setOptions(
  //             lstPortfolio.map((item) => ({
  //               key: item.pof_code,
  //               label: item.pof_name,
  //               value: item.pof_name + '#' + item.pof_code,
  //             }))
  //           );
  //         }
  //       },
  //       onError: (error: any) => {
  //         console.log(error);
  //       },
  //     }
  //   );

  //getProductByPofCode

  const { mutate: getProducts, isLoading: isProductLoading } = useMutation(
    ['getProductByPofCode'],
    (request: any) =>
      PortfolioApi.getProductByPofCode(request.pof_codes, request.params),
    {
      onSuccess: (response: any) => {
        const updatedData = response.data.map((item: any) => ({
          ...item,
          // chi_nhanh: '1005, 1006',
          // cua_hang: '1101',
        }));
        setProductData(updatedData || []);
        setProductTotalData(response.total || 0);
      },
      onError: (error: any) => {
        setProductData([]);
        setProductTotalData(0);
      },
    }
  );

  const { mutate: getAllProducts, isLoading: isSetAllProductLoading } =
    useMutation(
      ['getAllProducts'],
      () =>
        PortfolioApi.getProductByPofCode(listPortfolioSelected, {
          page: 1,
          page_size: total,
        }),

      {
        onSuccess: (response: any) => {
          if (response.status === STATUS.SUCCESS) {
            const updatedData = response.data.map((item: any) => ({
              ...item,
              // chi_nhanh: '1005, 1006',
              // cua_hang: '1101',
            }));
            setProductData(updatedData || []);
            setListProductSelected(updatedData);
          }
        },
        onError: (error: any) => {
          console.log(error);
        },
      }
    );

  const openModal = (content: string) => {
    setModalContent(content);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalContent('');
  };

  const successModal = () => {
    const allAreTrue = excelData.every((item) => item.status === 2);
    if (allAreTrue) {
      setModalSyncVisible(false);
      listPortfolioSelected &&
        listPortfolioSelected.length > 0 &&
        getAllProducts();
    } else {
      openModal(
        'Đang đồng bộ danh sách sản phẩm từ khuôn, vui lòng chờ trong giây lát'
      );
    }
  };

  useEffect(() => {
    setStep(1);
    if (listPortfolioSelected.length != 0) {
      getProducts({
        pof_codes: listPortfolioSelected,
        params: pagination,
      });
    }
  }, [pagination.page, listPortfolioSelected]);

  const onNextStep = () => {
    if (listProductSelected.length != 0) {
      const maMauCounts = listProductSelected.reduce(
        (counts: any, product: any) => {
          counts[product.ma_mau] = (counts[product.ma_mau] || 0) + 1;
          return counts;
        },
        {}
      );

      const duplicateMaMauKeys = Object.keys(maMauCounts).filter(
        (ma_mau) => maMauCounts[ma_mau] > 1
      );
      // console.log(listProductSelected);
      if (duplicateMaMauKeys.length > 0) {
        openModal(`Bạn đã chọn mẫu ${duplicateMaMauKeys.join(', ')} trùng`);
      } else {
        closeModal();
        history.push(`/declare-cart-review-info/${id}`, {
          listPofCode: listPortfolioSelected,
          listProductSelected: listProductSelected,
          edit: location.state?.edit || false,
        });
      }
    } else {
      openModal(
        'Chưa có mẫu sản phẩm nào được chọn, vui lòng chọn mẫu sản phẩm'
      );
    }
  };

  function handleCheckboxChange(record: IProduct, checked: boolean) {
    if (checked) {
      if (
        !listProductSelected.some(
          (item) =>
            item.ma_mau + item.pof_code == record.ma_mau + record.pof_code
        )
      ) {
        setListProductSelected([...listProductSelected, record]);
      }
    } else {
      const updatedList = listProductSelected.filter(
        (item) =>
          item.ma_mau + item.pof_code !== record.ma_mau + record.pof_code
      );
      setListProductSelected(updatedList);
    }
  }

  function generateExcel() {
    const data = [];

    // create title
    const headerRow = columns.map((column) => {
      if (column.dataIndex === 'isSelected') {
        return 'Đã chọn';
      } else {
        return column.title;
      }
    });
    data.push(headerRow);

    // create data
    listProductSelected.forEach((product) => {
      const rowData = columns.map((column) => {
        if (column.dataIndex === 'isSelected') {
          return true;
        }
        return product[column.dataIndex];
      });
      data.push(rowData);
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `mau_san_pham.xlsx`);
  }

  function handleUploadFile(info: UploadProps) {
    try {
      if (info.fileList) {
        const files = info.fileList.map((file: any) => {
          return file.originFileObj;
        });
        if (files.length != 0) {
          const file = info.fileList[0];
          setSelectedFile(file);
          const reader = new FileReader();

          reader.onload = (e) => {
            if (e.target) {
              const data = e.target.result;
              const workbook = XLSX.read(data, { type: 'array' });
              const firstSheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[firstSheetName];
              let excelData = XLSX.utils.sheet_to_json<any[]>(worksheet, {
                header: 1,
                range: 0,
              });
              if (excelData.length == 0 || excelData[0][0] != 'Đã chọn') {
                openModal('File không đúng mẫu, vui lòng tải mẫu');
                return;
              }
              excelData = excelData.slice(1);

              const products: IProduct[] = [];
              excelData.forEach((row) => {
                const product: any = {};

                for (let index = 0; index < row.length; index++) {
                  const value = row[index];
                  product[columns[index].dataIndex] =
                    columns[index].dataIndex == 'chi_nhanh' ||
                    columns[index].dataIndex == 'cua_hang'
                      ? value
                        ? value.toString()
                        : null
                      : value;
                }
                products.push(product);
              });
              openNotificationWithIcon('success', 'File đã được tải lên');
              setListProductSelected(products);
            }
          };
          const blob = file.originFileObj as Blob;
          reader.readAsArrayBuffer(blob);
        }
      }
    } catch (err) {
      openNotificationWithIcon('error', 'File không đúng định dạng mẫu');
    }
  }

  const productsData = [...products];

  listProductSelected.forEach((selectedItem) => {
    const index = productsData.findIndex(
      (productItem) =>
        productItem.ma_mau + productItem.pof_code ===
        selectedItem.ma_mau + selectedItem.pof_code
    );
    if (index !== -1) {
      productsData[index] = selectedItem;
    }
  });

  return (
    <DeclareCartPage>
      <Content>
        <div className="text-xl font-bold">2. Chọn danh mục</div>
        <p className="ml-4" style={{ marginTop: '14px', marginBottom: '8px' }}>
          Chọn danh mục
        </p>

        <Select
          mode="multiple"
          placeholder="Chọn danh mục"
          showSearch
          style={{ width: '100%' }}
          // onSearch={(value) => {
          //   searchPortfolio(value);
          // }}
          onChange={(values) => {
            const data = values.map((item) => {
              const arr = item.split('#');
              return arr[1];
            });
            setListProductSelected([]);
            setCheckAll(false);
            setProductData([]);
            setProductTotalData(0);
            setListPortfolioSelected(data || []);
            setPagination({ page: 1, page_size: pagination.page_size });
            // if (data && data.length > 0) {
            //   getProducts({
            //     pof_codes: data,
            //     params: { page: 1, page_size: pagination.page_size },
            //   });
            // }
          }}
          options={lstPortfolio?.data?.map((item) => ({
            key: item.pof_code,
            label: item.pof_name,
            value: item.pof_name + '#' + item.pof_code,
          }))}
        >
          {/* {lstPortfolio.map((item) => (
            <Select.Option key={item.pof_code} value={item}>
              {item.pof_name}
            </Select.Option>
          ))} */}
        </Select>
      </Content>
      <div style={{ margin: '20px 0' }}></div>
      <Content>
        <Row justify="space-between">
          <div className="text-xl font-bold">
            Mã mẫu trong {listPortfolioSelected.length} danh mục ({total})
          </div>
          <Row justify="end" align="middle" style={{ marginBottom: '20px' }}>
            <Space size={16}>
              <Button
                bgColor={'bg-white'}
                color={'text-primary-50'}
                border={'border-primary-50'}
                customClass="fix-border-radius"
                onClick={generateExcel}
              >
                <DownloadOutlined></DownloadOutlined>
                Tải file excel
              </Button>

              <Space></Space>
              <Upload
                accept=".xlsx,.xls,.csv"
                onChange={handleUploadFile}
                beforeUpload={() => false}
                fileList={[]}
                showUploadList={false}
              >
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-primary-50'}
                  customClass="fix-border-radius"
                >
                  <UploadOutlined></UploadOutlined>
                  Upload file
                </Button>
              </Upload>
            </Space>
          </Row>
        </Row>

        <Table
          loading={isSetAllProductLoading || isProductLoading}
          rowKey={(record) => record.ma_mau + record.pof_code}
          // rowKey={(record) => record.id}
          className="customTable"
          size="small"
          columns={columns}
          dataSource={productsData || []}
          scroll={{ x: 970 }}
          pagination={{
            className: 'flex items-center',
            current: pagination.page,
            pageSize: pagination.page_size,
            total: total,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            onChange(page, pageSize) {
              setPagination({ page, page_size: pageSize });
            },
          }}
        />
      </Content>

      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify="end"
        style={{ marginTop: '20px', marginRight: '2px' }}
      >
        <Form.Item>
          <Button onClick={onNextStep}>Tiếp theo</Button>
        </Form.Item>
      </Row>
      <PopupConfirmBase
        isVisible={isModalOpen}
        title={'Thông báo'}
        description={modalContent}
        onlyOK={true}
        onOk={() => {
          closeModal();
        }}
      ></PopupConfirmBase>
    </DeclareCartPage>
  );
}
